import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

//redux
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

import assetURLs from 'constants/assetURLs';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { generateLoginOTP } from 'services/api/auth';
import { resetAuthFlags, setError } from 'slices/auth/reducer';
import { getErrorMessage } from 'utils/helpers';
import { login } from 'slices/auth/thunk';
import VerifyOTP from 'Components/auth/VerifyOTP';
//import images

const Login = (props: any) => {

    const dispatch: AppDispatch = useDispatch();

    const [loader, setLoader] = useState<boolean>(false);
    const { error } = useSelector((state: RootState) => state.auth);

    const [otpSent, setOTPSent] = useState<boolean>(false);

    const [userInfo, setUserInfo] = useState<{ username: string, otp: string }>({ username: '', otp: '' });

    const sendOTP = async (userCredentials: { username: string }) => {
        try {
            dispatch(setError(null));
            setLoader(true);
            const status = await generateLoginOTP(userCredentials);
            if (status) {
                setOTPSent(true)
            }
        } catch (error) {
            console.log(error)
            dispatch(setError(getErrorMessage(error, 'Failed to send OTP')));
        } finally {
            setLoader(false);
        }
    }

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email").email("Please enter a valid Email Address"),
        }),
        onSubmit: async (values) => {
            setUserInfo({ username: values.email, otp: '' });
            await sendOTP({ username: values.email });
        }
    });

    const handleVerification = async (otp: string) => {
        const response = await dispatch(login({ username: userInfo.username, otp }))
        if (response.meta.requestStatus === 'fulfilled') {
            props.router.navigate('/');
        }
    }

    useEffect(() => {
        dispatch(resetAuthFlags());
    }, [dispatch])

    document.title = "Sign In |  Influns - Where Your Influence Matters";
    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={assetURLs.LOGO_WHITE} alt="" height="50" />
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {
                            !otpSent ? (
                                <Row className="justify-content-center h-100">
                                    <Col md={8} lg={6} xl={5}>
                                        <Card className="mt-4">
                                            <CardBody className="p-4">
                                                <div className="text-center mt-2">
                                                    <h5 className="text-primary">Welcome Back !</h5>
                                                    <p className="text-muted">Sign in to continue to Influns.</p>
                                                </div>
                                                {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                                <div className="p-2 mt-4">
                                                    <Form
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            validation.handleSubmit();
                                                            return false;
                                                        }}
                                                        action="#">

                                                        <div className="mb-3">
                                                            <Label htmlFor="email" className="form-label">Email</Label>
                                                            <Input
                                                                name="email"
                                                                className="form-control"
                                                                placeholder="Enter email"
                                                                type="email"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.email || ""}
                                                                invalid={
                                                                    validation.touched.email && validation.errors.email ? true : false
                                                                }
                                                            />
                                                            {validation.touched.email && validation.errors.email ? (
                                                                <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                            ) : null}
                                                        </div>

                                                        <div className="mt-4">
                                                            <Button
                                                                disabled={loader}
                                                                className="primary-gradient w-100" type="submit">
                                                                {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}
                                                                Generate OTP
                                                            </Button>
                                                        </div>

                                                        <div className="mt-4 text-center">
                                                            <p className="mb-0">Don't have an account? <Link to="/register" className="fw-semibold text-primary text-decoration-underline"> Sign Up </Link></p>
                                                        </div>

                                                    </Form>
                                                </div>
                                            </CardBody>
                                        </Card>

                                    </Col>
                                </Row>
                            ) :
                                (
                                    <VerifyOTP
                                        username={userInfo.username}
                                        changeEmail={() => setOTPSent(false)}
                                        resendOTP={async () => {
                                            return await generateLoginOTP({ username: userInfo.username });
                                        }}
                                        submitButtonText='Sign In'
                                        handleVerification={handleVerification}
                                    />
                                )
                        }


                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);